import { Component } from '@angular/core';

@Component({
  selector: 'app-user-stats',
  templateUrl: './user-stats.component.html',
  styleUrl: './user-stats.component.scss'
})
export class UserStatsComponent {

  // نشاط المستخدم - عدد عمليات البحث في اليوم
  activityData = {
    labels: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    datasets: [
      {
        label: 'عدد عمليات البحث',
        data: [5, 8, 12, 7, 10, 6, 4],
        fill: false,
        borderColor: '#42A5F5',
        tension: 0.4
      }
    ]
  };

  // تسجيل دخول المستخدم - عدد مرات الدخول في الأسبوع
  loginData = {
    labels: ['الأسبوع 1', 'الأسبوع 2', 'الأسبوع 3', 'الأسبوع 4'],
    datasets: [
      {
        label: 'تسجيل الدخول',
        data: [12, 19, 8, 15],
        backgroundColor: '#66BB6A'
      }
    ]
  };

  // إحصائيات التدريب
  trainingStats = {
    attended: 12,
    upcoming: 3,
    missed: 2,
    passed: 9,
    failed: 3,
    avgGrade: 82
  };

  trainingBreakdown = [
    { name: 'دورة القيادة', status: 'ناجح', date: '2025-01-15', grade: 90 },
    { name: 'إدارة الوقت', status: 'فشل', date: '2025-02-02', grade: 45 },
    { name: 'التواصل الفعال', status: 'مجدول', date: '2025-09-20', grade: '-' },
    { name: 'تحليل البيانات', status: 'حضر', date: '2025-08-10', grade: 78 }
  ];

  // نتائج التقييمات
  assessmentStats = {
    attempted: 7,
    totalQuestions: 120,
    correctAnswers: 95,
    avgGrade: 79,
    avgTime: '18 دقيقة'
  };

  // نتائج الاستبيانات
  surveyStats = {
    totalTaken: 5,
    totalQuestions: 60
  };
}
